// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XPU3","top":"styles_top__1o1_b","left":"styles_left__2gj6H","description":"styles_description__1QHZk"};